<!-- PaymentIcon.vue -->
<template>
    <svg :class="iconClass" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1C5.92488 1 1 5.92488 1 12C1 14.1387 1.61101 16.1344 2.66706 17.8233L1 23L6.17667 21.3329C7.86558 22.389 9.86129 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92488 18.0751 1 12 1Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.1653 12C13.1653 12.6435 12.6435 13.1653 12 13.1653C11.3565 13.1653 10.8347 12.6435 10.8347 12C10.8347 11.3565 11.3565 10.8347 12 10.8347C12.6435 10.8347 13.1653 11.3565 13.1653 12Z" fill="#333333"/>
        <path d="M17.8263 12C17.8263 12.6435 17.3046 13.1653 16.661 13.1653C16.0175 13.1653 15.4958 12.6435 15.4958 12C15.4958 11.3565 16.0175 10.8347 16.661 10.8347C17.3046 10.8347 17.8263 11.3565 17.8263 12Z" fill="#333333"/>
        <path d="M8.50425 12C8.50425 12.6435 7.98254 13.1653 7.33899 13.1653C6.69544 13.1653 6.17374 12.6435 6.17374 12C6.17374 11.3565 6.69544 10.8347 7.33899 10.8347C7.98254 10.8347 8.50425 11.3565 8.50425 12Z" fill="#333333"/>
    </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>